import React, { FC } from 'react';
import { Dialog } from '@headlessui/react';
import { NewsArticle } from '../../types/news';
import { Modal } from '../Modal';
import { prettifyDate } from '../../utils/helpers';
import { FormattedMessage } from 'react-intl';
import { useInteractionTimeout } from '../../hooks/useInteractionTimeout';
import { useConfig } from '../../providers/ConfigProvider';
import Button from '../Button';

interface Props {
  newsArticle?: NewsArticle;
  show: boolean;
  onClose: () => void;
}

export const NewsArticleModal: FC<Props> = ({ newsArticle, show, onClose }) => {
  // Works better if close is guaranteed to happen slightly before regular interaction timeout
  const { interactionTimeout } = useConfig();
  useInteractionTimeout(interactionTimeout - 2000, onClose);

  if (!show || !newsArticle) {
    return null;
  }

  const { published, image, title, text } = newsArticle;
  const date = new Date(published);

  return (
    <Modal open={true} onClose={onClose} className="flex flex-col gap-12 w-4/5">
      <div className="flex w-full flex-col gap-3">
        {image ? (
          <div className="mb-7 flex h-96 w-full">
            <img
              src={image}
              alt="news article"
              className="h-full w-full bg-gray-800 object-cover"
            />
          </div>
        ) : null}
        <Dialog.Title as="h3" className="text-3xl font-medium text-white">
          {title}
        </Dialog.Title>
        <p className="text-gray-200">
          <FormattedMessage defaultMessage="Publicerat" /> {prettifyDate(date)}
        </p>
        <p
          className="pointer-events-none text-gray-100"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
      <Button onClick={onClose}>
        <FormattedMessage defaultMessage="Stäng" />
      </Button>
    </Modal>
  );
};
